'use client'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import type { VariantProps } from 'class-variance-authority'

import { cn } from '@/shared/helpers/styles.helper'
// buttonVariants est dans button-variants.ts (sans "use client") pour pouvoir être importé
// depuis des Server Components — nécessaire avec Base UI dont le render prop
// ne peut pas traverser une server/client boundary en Next.js 15.
import { buttonVariants } from '@/shared/ui/button/button-variants'

// Bouton de la charte : applique la variante et la taille choisies au bouton Base UI
function Button({
  className,
  variant = 'primary-flat',
  size = 'default',
  ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
  return <ButtonPrimitive data-slot="button" className={cn(buttonVariants({ variant, size, className }))} {...props} />
}

export { Button, buttonVariants }
